import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class VariantEfficiencyRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    variantCode: string;

}